/* ============ A LITTLE WRONG — theme.js ============ */
(function(){
'use strict';
const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];
const CFG=window.ALW||{};
const money=c=>{const f=CFG.moneyFormat||'${{amount}}';const v=(c/100).toFixed(2);return f.replace('{{amount}}',v).replace('{{amount_no_decimals}}',Math.round(c/100)).replace('{{amount_with_comma_separator}}',v.replace('.',','));};

/* ---------- overlay / toast ---------- */
const overlay=$('#site-overlay'), toastEl=$('#toast');
let toastT;
function toast(msg){toastEl.textContent=msg;toastEl.hidden=false;toastEl.classList.add('show');clearTimeout(toastT);toastT=setTimeout(()=>{toastEl.classList.remove('show');setTimeout(()=>toastEl.hidden=true,300);},2600);}
function lockScroll(on){document.body.style.overflow=on?'hidden':'';}
function closeAll(){$$('.drawer.is-open,.modal.is-open,.mega-drawer.is-open,.mobile-menu.is-open').forEach(e=>{e.classList.remove('is-open');e.setAttribute('aria-hidden','true');});overlay.classList.remove('show');lockScroll(false);}
function openLayer(el){closeAll();el.classList.add('is-open');el.setAttribute('aria-hidden','false');overlay.classList.add('show');lockScroll(true);}
overlay.addEventListener('click',closeAll);
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeAll();});
window.ALWToast=toast;

/* ---------- announcement rotator ---------- */
(function(){const track=$('.announce__track');if(!track)return;const msgs=$$('.announce__msg',track);if(msgs.length<2)return;let i=0;const speed=parseInt(($('#announce')?.dataset.speed)||5,10)*1000;
const show=n=>{msgs.forEach((m,k)=>m.classList.toggle('is-active',k===n));};
$('[data-announce-prev]')?.addEventListener('click',()=>{i=(i-1+msgs.length)%msgs.length;show(i);});
$('[data-announce-next]')?.addEventListener('click',()=>{i=(i+1)%msgs.length;show(i);});
setInterval(()=>{i=(i+1)%msgs.length;show(i);},6000);})();

/* ---------- hero slideshow ---------- */
$$('[data-hero-slides]').forEach(slides=>{
  const all=$$('.hero__slide',slides), dots=$$('[data-hero-dot]');
  if(all.length<2)return;let i=0,timer;
  const go=n=>{i=(n+all.length)%all.length;all.forEach((s,k)=>s.classList.toggle('is-active',k===i));dots.forEach((d,k)=>d.classList.toggle('is-active',k===i));};
  dots.forEach(d=>d.addEventListener('click',()=>{go(+d.dataset.heroDot);restart();}));
  const restart=()=>{clearInterval(timer);timer=setInterval(()=>go(i+1),6000);};
  restart();
});

/* ---------- header layers ---------- */
$('#dept-btn')?.addEventListener('click',()=>openLayer($('#mega-drawer')));
$('[data-close-mega]')?.addEventListener('click',closeAll);
$('#mobile-menu-btn')?.addEventListener('click',()=>openLayer($('#mobile-menu')));
$('[data-close-mobile]')?.addEventListener('click',closeAll);
$('#cart-btn')?.addEventListener('click',()=>openLayer($('#cart-drawer')));
$('[data-close-drawer]')?.addEventListener('click',closeAll);

/* ---------- cart ---------- */
async function getCart(){return (await fetch('/cart.js')).json();}
function shipBars(cart){$$('[data-ship-bar]').forEach(bar=>{
  const th=+bar.dataset.threshold||5000, total=cart.total_price, msg=$('[data-ship-msg]',bar), fill=$('[data-ship-fill]',bar);
  const pct=Math.min(100,Math.round(total/th*100));fill.style.width=pct+'%';
  msg.innerHTML=total>=th?CFG.tFreeDone||'FREE shipping unlocked':(CFG.tFreeToGo||'{{ amount }} away').replace('{{ amount }}','<strong>'+money(th-total)+'</strong>');
});}
function renderDrawer(cart){
  const wrap=$('[data-drawer-items]');if(!wrap)return;
  $('[data-drawer-count]').textContent=cart.item_count;
  $('#cart-count').textContent=cart.item_count;
  $('[data-drawer-subtotal]').textContent=money(cart.total_price);
  if(!cart.items.length){wrap.innerHTML='<p class="muted drawer__empty">'+(CFG.tEmpty||'Your cart is empty.')+'</p>';}
  else wrap.innerHTML=cart.items.map(it=>`
    <div class="drawer-item" data-key="${it.key}">
      <a href="${it.url}"><img src="${it.image.replace(/(\.[a-z]+)$/i,'_200x$1')}" alt="" loading="lazy"></a>
      <div class="drawer-item__info"><a href="${it.url}">${it.product_title}</a>
        ${it.variant_title?`<p class="muted">${it.variant_title}</p>`:''}
        <div class="qty qty--sm"><button data-dec aria-label="Decrease">−</button><span>${it.quantity}</span><button data-inc aria-label="Increase">+</button></div>
      </div>
      <div class="drawer-item__right"><strong>${money(it.final_line_price)}</strong><button class="link-btn" data-remove aria-label="Remove">✕</button></div>
    </div>`).join('');
  shipBars(cart);
}
async function refreshCart(open){const cart=await getCart();renderDrawer(cart);if(open)openLayer($('#cart-drawer'));}
async function addToCart(id,qty=1,open=true){
  const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id,quantity:qty})});
  if(!r.ok){toast(CFG.tError||'Something went wrong');return;}
  toast(CFG.tAdded||'Added to cart');refreshCart(open);
}
async function changeCart(key,qty){await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})});refreshCart(false);}
document.addEventListener('click',e=>{
  const q=e.target.closest('[data-quick-add]');if(q){addToCart(+q.dataset.quickAdd,1);return;}
  const d=e.target.closest('#cart-drawer [data-dec],#cart-drawer [data-inc],#cart-drawer [data-remove]');
  if(d){const key=d.closest('.drawer-item').dataset.key;const cur=+$('.qty span',d.closest('.drawer-item')).textContent;
    if(d.hasAttribute('data-remove'))changeCart(key,0);
    else changeCart(key,cur+(d.hasAttribute('data-inc')?1:-1));return;}
});
$('[data-drawer-checkout]')?.addEventListener('click',()=>location.href='/checkout');
/* cart page */
$$('#cart-form [data-cart-qty]').forEach(inp=>inp.addEventListener('change',async()=>{await changeCart(inp.dataset.cartQty,Math.max(0,+inp.value));location.reload();}));
$$('#cart-form [data-cart-remove]').forEach(b=>b.addEventListener('click',async()=>{await changeCart(b.dataset.cartRemove,0);location.reload();}));
$$('#cart-form [data-cart-dec],#cart-form [data-cart-inc]').forEach(b=>b.addEventListener('click',async()=>{const inp=b.parentElement.querySelector('input');inp.value=Math.max(0,+inp.value+(b.hasAttribute('data-cart-inc')?1:-1));inp.dispatchEvent(new Event('change'));}));
(function(){const bar=$('.cart-page [data-ship-bar]');if(bar)getCart().then(shipBars);})();

/* ---------- product form / swatches ---------- */
function colorMatch(alt,src,color){
  if(!color)return true;const c=color.toLowerCase(),a=(alt||'').toLowerCase();
  if(a.includes(c))return true;
  const words=c.split(/[\s-]+/).filter(Boolean);
  const initials=words.map(w=>w[0]).join('');
  const segs=(src||'').toLowerCase().split(/[\/\-_\.]/).filter(s=>s.length===1||s===initials);
  return words.some(w=>segs.includes(w[0]))||segs.includes(initials);
}
$$('[data-product]').forEach(root=>{
  const jsonEl=$('[data-product-json]',root);if(!jsonEl)return;
  const product=JSON.parse(jsonEl.textContent);
  const form=$('[data-product-form]',root), vidInput=$('[data-variant-id]',root);
  const colorFilter=root.dataset.colorFilter==='true';
  const colorIdx=(()=>{const names=(CFG.swatchColors||'Color,Colour').split(',').map(s=>s.trim().toLowerCase());return product.options.findIndex(o=>names.includes(o.toLowerCase()));})();
  const slides=$$('[data-gallery] [data-media-id]',root), thumbs=$$('[data-thumbs] [data-thumb]',root);
  function activate(id){slides.forEach(s=>s.classList.toggle('is-active',s.dataset.mediaId==id));thumbs.forEach(t=>t.classList.toggle('is-active',t.dataset.thumb==id));}
  thumbs.forEach(t=>t.addEventListener('click',()=>activate(t.dataset.thumb)));
  /* swipe on the main gallery image */
  const galMain=$('[data-gallery] .product__main',root);
  if(galMain&&slides.length>1){let sx=null;
    galMain.addEventListener('touchstart',e=>{sx=e.touches[0].clientX;},{passive:true});
    galMain.addEventListener('touchend',e=>{if(sx==null)return;const dx=e.changedTouches[0].clientX-sx;sx=null;
      if(Math.abs(dx)<40)return;const ids=slides.map(s=>s.dataset.mediaId);
      let cur=slides.findIndex(s=>s.classList.contains('is-active'));if(cur<0)cur=0;
      activate(ids[(cur+(dx<0?1:-1)+ids.length)%ids.length]);},{passive:true});}
  function filterGallery(color){if(!colorFilter)return;thumbs.forEach(t=>{const img=$('img',t);const ok=colorMatch(t.dataset.mediaAlt,img?.currentSrc||img?.src,color);t.classList.toggle('is-hidden',!ok);});
    const vis=thumbs.filter(t=>!t.classList.contains('is-hidden'));if(vis.length)activate(vis[0].dataset.thumb);}
  function selectedOptions(){return $$('.swatch-group',root).map(g=>{const c=$('input:checked',g);return c?c.value:null;});}
  function findVariant(){const sel=selectedOptions();return product.variants.find(v=>v.options.every((o,i)=>o===sel[i]));}
  function sync(){
    const v=findVariant()||product.variants.find(x=>x.available)||product.variants[0];if(!v)return;
    vidInput.value=v.id;
    $$('.swatch-group',root).forEach((g,gi)=>{const val=v.options[gi];const lbl=$('[data-option-value]',g);if(lbl)lbl.textContent=val;
      $$('.swatch',g).forEach(sw=>{const inp=$('input',sw);const on=inp.value===val;inp.checked=on;sw.classList.toggle('is-selected',on);});});
    const priceEl=$('.product__price',root);
    if(priceEl){let h='';if(v.compare_at_price>v.price)h=`<div class="price price--sale"><span class="price__now">${money(v.price)}</span><s class="price__was">${money(v.compare_at_price)}</s><span class="price__save">−${Math.round((v.compare_at_price-v.price)*100/v.compare_at_price)}%</span></div>`;
      else h=`<div class="price"><span class="price__now">${money(v.price)}</span></div>`;priceEl.innerHTML=h;}
    const btn=$('[data-add-to-cart]',root);
    if(btn){btn.disabled=!v.available;btn.innerHTML=v.available?(CFG.tAdd||'Add to cart'):(CFG.tSoldOut||'Sold out');}
    const sku=$('.product__sku',root);if(sku&&v.sku)sku.innerHTML=(CFG.tSku||'SKU')+': '+v.sku;
    if(v.featured_media){const m=product.media.find(m=>m.id===v.featured_media.id);if(m)activate(m.id);}
    if(colorIdx>=0)filterGallery(v.options[colorIdx]);
  }
  root.addEventListener('change',e=>{if(e.target.matches('.swatch input'))sync();});
  sync();
  form.addEventListener('submit',async e=>{e.preventDefault();await addToCart(+vidInput.value,+(form.quantity?.value||1));});
});
/* qty steppers */
document.addEventListener('click',e=>{
  const b=e.target.closest('[data-qty-minus],[data-qty-plus]');if(!b)return;
  const inp=b.parentElement.querySelector('input');if(!inp)return;
  inp.value=Math.max(1,+inp.value+(b.hasAttribute('data-qty-plus')?1:-1));
});
/* accordions */
document.addEventListener('click',e=>{const h=e.target.closest('[data-acc-head]');if(h)h.closest('.accordion__item').classList.toggle('open');});

/* ---------- quick view ---------- */
const qv=$('#quick-view');let qvVariant=null;
document.addEventListener('click',async e=>{
  const b=e.target.closest('[data-quick-view]');if(!b)return;e.preventDefault();
  const p=await (await fetch('/products/'+b.dataset.quickView+'.js')).json();
  $('[data-qv-img]',qv).src=p.featured_image?.replace(/(\.[a-z]+)$/i,'_700x$1')||'';
  $('[data-qv-img]',qv).alt=p.title;
  $('[data-qv-vendor]',qv).textContent=p.vendor||'';
  $('[data-qv-title]',qv).textContent=p.title;
  $('[data-qv-price]',qv).innerHTML=`<span class="price__now">${money(p.price)}</span>`+(p.compare_at_price>p.price?`<s class="price__was">${money(p.compare_at_price)}</s>`:'');
  $('[data-qv-link]',qv).href='/products/'+p.handle;
  const sel=$('[data-qv-variants]',qv);sel.innerHTML=p.variants.map(v=>`<option value="${v.id}" ${v.available?'':'disabled'}>${v.title} — ${money(v.price)}</option>`).join('');
  qvVariant=p.variants.find(v=>v.available)?.id||p.variants[0].id;
  sel.onchange=()=>qvVariant=+sel.value;
  openLayer(qv);
});
$('[data-qv-add]')?.addEventListener('click',()=>{if(qvVariant)addToCart(qvVariant,1,false).then(()=>refreshCart(true));});
$('[data-close-qv]')?.addEventListener('click',closeAll);

/* ---------- compare ---------- */
const CKEY='alw-compare', tray=$('#compare-tray'), cmodal=$('#compare-modal');
const getC=()=>{try{return JSON.parse(localStorage.getItem(CKEY))||[]}catch{return[]}};
const setC=a=>localStorage.setItem(CKEY,JSON.stringify(a));
const pCache={};
async function pJSON(handle){if(!pCache[handle])pCache[handle]=await (await fetch('/products/'+handle+'.js')).json();return pCache[handle];}
function paintCompareBtns(){const ids=getC().map(x=>x.id);$$('[data-compare-add]').forEach(b=>b.classList.toggle('is-active',ids.includes(+b.dataset.compareAdd)));}
async function renderTray(){
  const items=getC();tray.hidden=!items.length;
  $('[data-compare-count]',tray).textContent=items.length;
  $('[data-compare-items]',tray).innerHTML=items.map(x=>`<img src="${x.img}" alt="${x.title.replace(/"/g,'')}" title="${x.title.replace(/"/g,'')}">`).join('');
  paintCompareBtns();
}
document.addEventListener('click',async e=>{
  const b=e.target.closest('[data-compare-add]');
  if(b){const id=+b.dataset.compareAdd,card=b.closest('[data-product-card]');let items=getC();
    if(items.some(x=>x.id===id)){items=items.filter(x=>x.id!==id);toast(CFG.tCmpRm||'Removed from compare');}
    else{if(items.length>=4){toast(CFG.tCmpMax||'You can compare up to 4 products.');return;}
      const p=await pJSON(card?.dataset.handle||b.dataset.handle||'');
      if(!p){toast(CFG.tError||'Something went wrong');return;}
      items.push({id,handle:p.handle,title:p.title,img:(p.featured_image||'').replace(/(\.[a-z]+)$/i,'_200x$1'),price:p.price,compare:p.compare_at_price,vendor:p.vendor,available:p.available});}
    setC(items);renderTray();return;}
  if(e.target.closest('[data-compare-clear]')){setC([]);renderTray();return;}
  if(e.target.closest('[data-compare-open]')){
    const items=getC();if(!items.length)return;
    const ps=await Promise.all(items.map(x=>pJSON(x.handle)));
    const row=(label,fn)=>`<div class="compare-row"><div class="head">${label}</div>${ps.map(p=>`<div>${fn(p)}</div>`).join('')}</div>`;
    $('[data-compare-table]',cmodal).innerHTML=
      row('',p=>`<img src="${(p.featured_image||'').replace(/(\.[a-z]+)$/i,'_200x$1')}" alt="">`)+
      row('Product',p=>`<a href="/products/${p.handle}"><strong>${p.title}</strong></a>`)+
      row('Price',p=>money(p.price))+
      row('Vendor',p=>p.vendor||'—')+
      row('Availability',p=>p.available?'In stock':'Sold out')+
      row('',p=>`<button class="btn btn--accent btn--sm" data-quick-add="${p.variants.find(v=>v.available)?.id||p.variants[0].id}">Add to cart</button>`);
    openLayer(cmodal);return;}
  if(e.target.closest('[data-close-compare]')){closeAll();return;}
});
renderTray();

/* ---------- collection: sort + filters drawer ---------- */
$('[data-sort]')?.addEventListener('change',e=>{const u=new URL(location.href);u.searchParams.set('sort_by',e.target.value);location.href=u;});
$('#filter-btn')?.addEventListener('click',()=>{const f=$('#filters');if(!f)return;f.classList.add('is-open');f.setAttribute('aria-hidden','false');overlay.classList.add('show');lockScroll(true);});
$('#filters [data-close]')?.addEventListener('click',closeAll);

/* ---------- login recover ---------- */
$('[data-recover]')?.addEventListener('click',e=>{e.preventDefault();$('#recover').hidden=false;});
})();
